import api from '@/lib/api'

const { collectFormTouches, leadSourceFields, matchingFbc, buildWaSearchParams } = require('./formTouches')

export const ATTRIBUTION_LS_KEY = 'el_attribution'
export const ATTRIBUTION_SYNC_LS_KEY = 'el_attribution_synced'
export const ATTRIBUTION_MAX_AGE = 60 * 60 * 24 * 90

export const CLICK_ID_KEYS = [
  'gclid',
  'gbraid',
  'wbraid',
  'fbclid',
  'ttclid',
  'ScCid',
  'msclkid',
]

export const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
]

export const FIRST_TOUCH_KEYS = ['referrer', 'landing_page', 'timestamp', 'sid']

export const ATTRIBUTION_FIELD_KEYS = CLICK_ID_KEYS.concat(UTM_KEYS, FIRST_TOUCH_KEYS, ['fbc'])

const COOKIE_NAME = {
  referrer: 'first_referrer',
  sid: 'wa_ref',
  fbc: '_fbc',
}

function cookieName(key) {
  return COOKIE_NAME[key] || key
}

export function captureAttribution() {
  if (typeof window === 'undefined') return

  var LS_KEY = 'el_attribution'
  var CLICK_IDS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'ScCid', 'msclkid']
  var stored = {}

  function getCookie(n) {
    var m = document.cookie.match('(^|;)\\s*' + n.replace(/([$?*|{}()[\]\\/+^])/g, '\\$1') + '\\s*=\\s*([^;]+)')
    return m ? decodeURIComponent(m[2]) : ''
  }

  function cookieNameFor(key) {
    if (key === 'referrer') return 'first_referrer'
    if (key === 'sid') return 'wa_ref'
    if (key === 'fbc') return '_fbc'
    return key
  }

  try {
    stored = JSON.parse(localStorage.getItem(LS_KEY) || '{}') || {}
  } catch (e) {
    stored = {}
  }

  function getStored(key) {
    if (stored[key] && key === 'sid') stored[key] = stored[key].replace(/^\s+|\s+$/g, '')
    if (stored[key]) return stored[key]
    var fromCookie = getCookie(cookieNameFor(key))
    if (!fromCookie && key === 'sid') fromCookie = sidFromElAttr() || getCookie('wa_sid')
    if (fromCookie) {
      if (key === 'sid') fromCookie = fromCookie.replace(/^\s+|\s+$/g, '')
      stored[key] = fromCookie
      return fromCookie
    }
    return ''
  }

  function persist(key, value, overwrite) {
    if (!value) return
    if (!overwrite && getStored(key)) return
    stored[key] = value
  }

  function sidFromElAttr() {
    var match = document.cookie.match(/(?:^|; )el_attr=([^;]*)/)
    if (!match) return ''
    try {
      var data = JSON.parse(decodeURIComponent(match[1]))
      if (data && Number(data.v) === 2 && data.sid) return String(data.sid).replace(/^\s+|\s+$/g, '')
    } catch (e) {}
    return ''
  }

  function makeSid() {
    var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    var sid = ''
    var i
    for (i = 0; i < 8; i++) {
      sid += chars.charAt(Math.floor(Math.random() * chars.length))
    }
    return sid
  }

  var params = new URLSearchParams(location.search)
  var nowMs = Date.now()
  var i
  var value

  function validClickId(key, raw) {
    if (!raw) return false
    var dotted = key === 'ttclid' || key === 'ScCid'
    var max = key === 'msclkid' ? 200 : 500
    if (raw.length < 10 || raw.length > max) return false
    var n
    var c
    for (n = 0; n < raw.length; n++) {
      c = raw.charAt(n)
      var ok =
        (c >= 'A' && c <= 'Z') ||
        (c >= 'a' && c <= 'z') ||
        (c >= '0' && c <= '9') ||
        c === '_' ||
        c === '-' ||
        (dotted && c === '.')
      if (!ok) return false
    }
    return true
  }

  for (i = 0; i < CLICK_IDS.length; i++) {
    value = params.get(CLICK_IDS[i])
    if (value && validClickId(CLICK_IDS[i], value)) persist(CLICK_IDS[i], value, true)
  }

  params.forEach(function (v, k) {
    if (k.indexOf('utm_') === 0 && v) persist(k, v.length > 150 ? v.slice(0, 150) : v, true)
  })

  persist('referrer', document.referrer || 'direct', false)
  persist('landing_page', location.href, false)
  persist('timestamp', new Date().toISOString(), false)
  persist('sid', makeSid(), false)

  var fbclidUrl = params.get('fbclid')
  if (fbclidUrl && validClickId('fbclid', fbclidUrl)) {
    var prevFbc = getStored('fbc')
    var prevId = prevFbc ? prevFbc.slice(prevFbc.lastIndexOf('.') + 1) : ''
    if (prevId !== fbclidUrl) persist('fbc', 'fb.1.' + nowMs + '.' + fbclidUrl, true)
  }

  function referrerHost(referrer) {
    var value = referrer || ''
    if (!value || value === 'direct') return ''
    var withScheme = value.indexOf('://') === -1 ? 'https://' + value : value
    var match = /^https?:\/\/([^/?#]+)/i.exec(withScheme)
    return match ? match[1] : ''
  }

  function readTouchList() {
    var list = []
    try {
      list = JSON.parse(localStorage.getItem('el_touches') || '[]') || []
    } catch (e) {
      list = []
    }
    if (!Array.isArray(list)) list = []
    return list
  }

  function knownClick(list, idType, clickId, rawKey) {
    var n
    var item
    for (n = 0; n < list.length; n++) {
      item = list[n] || {}
      if (item.id_type === idType && item.click_id === clickId) return true
      if (rawKey && item[rawKey] === clickId) return true
    }
    return false
  }

  function saveVisitTouch() {
    var defs = [
      ['google', 'gclid', 'gclid'],
      ['google', 'gbraid', 'gbraid'],
      ['google', 'wbraid', 'wbraid'],
      ['meta', 'fbclid', 'fbclid'],
      ['tiktok', 'ttclid', 'ttclid'],
      ['snap', 'sccid', 'ScCid'],
      ['ms', 'msclkid', 'msclkid'],
    ]
    var fbc = getStored('fbc') || ''
    var fbcMatch = /^fb\.1\.(\d{10,})\.([A-Za-z0-9_-]{10,500})$/.exec(fbc)
    var visitTs = new Date(nowMs).toISOString()
    var landing = location.pathname || '/'
    var host = referrerHost(document.referrer || '')
    var utm = {}
    var hasUtm = false
    var list = readTouchList()
    var sawClick = false
    var i
    var raw
    var def
    var touch
    params.forEach(function (v, k) {
      if (k.indexOf('utm_') !== 0 || !v) return
      utm[k] = v.length > 150 ? v.slice(0, 150) : v
      hasUtm = true
    })
    function stampUtm(target) {
      var name
      for (name in utm) {
        if (Object.prototype.hasOwnProperty.call(utm, name)) target[name] = utm[name]
      }
    }
    for (i = 0; i < defs.length; i++) {
      def = defs[i]
      raw = params.get(def[2])
      if (def[2] === 'ScCid' && !raw) raw = params.get('sccid')
      if (!raw || !validClickId(def[2], raw)) continue
      sawClick = true
      if (knownClick(list, def[1], raw, def[2])) continue
      touch = {
        system: def[0],
        id_type: def[1],
        click_id: raw,
        referrer_host: host,
        landing_path: landing,
        ts: visitTs,
        ts_kind: 'visit',
      }
      if (def[1] === 'fbclid' && fbcMatch && fbcMatch[2] === raw) {
        touch.ts = new Date(Number(fbcMatch[1])).toISOString()
        touch.ts_kind = 'click'
      }
      stampUtm(touch)
      list.push(touch)
    }
    if (!sawClick && hasUtm) {
      touch = {
        system: 'utm_only',
        id_type: '',
        click_id: '',
        referrer_host: host,
        landing_path: landing,
        ts: visitTs,
        ts_kind: 'visit',
      }
      stampUtm(touch)
      var sig = [touch.landing_path, touch.utm_source || '', touch.utm_campaign || ''].join('\0')
      var dup = false
      for (i = 0; i < list.length; i++) {
        raw = list[i] || {}
        if (raw.system !== 'utm_only') continue
        if ([raw.landing_path || '', raw.utm_source || '', raw.utm_campaign || ''].join('\0') === sig) dup = true
      }
      if (!dup) list.push(touch)
    }
    if (list.length > 30) list = list.slice(list.length - 30)
    try {
      localStorage.setItem('el_touches', JSON.stringify(list))
    } catch (e) {}
  }

  saveVisitTouch()

  function patchWaLinks() {
    var links = document.querySelectorAll('a[href*="wa.me"]')
    var n
    var href
    var next
    for (n = 0; n < links.length; n++) {
      href = links[n].getAttribute('href') || ''
      if (!href || href.indexOf('wa.me') === -1) continue
      next = buildRouteFromStored(stored, location.pathname || '/', 'content')
      if (next) links[n].setAttribute('href', next)
    }
  }

  function buildRouteFromStored(data, path, src) {
    var route = new URLSearchParams()
    var safe = path || '/'
    var search
    var keys
    var visitKeys
    var list
    var has
    var i
    var n
    var key
    var value
    var idType
    var visitTs
    var winner
    var winnerAt
    var name
    if (safe.charAt(0) !== '/' || safe.indexOf('//') === 0 || safe.length > 120) safe = '/'
    route.set('src', src || 'site')
    route.set('p', safe)
    search = new URLSearchParams(location.search)
    keys = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'ScCid', 'msclkid']
    has = false
    for (i = 0; i < keys.length; i++) {
      key = keys[i]
      value = search.get(key) || ''
      if (key === 'ScCid' && !value) value = search.get('sccid') || ''
      if (!value || !validClickId(key, value)) continue
      route.set(key, value)
      has = true
    }
    search.forEach(function (v, k) {
      if (k.indexOf('utm_') !== 0 || !v) return
      route.set(k, v.length > 150 ? v.slice(0, 150) : v)
      has = true
    })
    list = readTouchList()
    if (has) {
      if (route.get('fbclid') && data && data.fbc) route.set('fbc', data.fbc)
      visitKeys = ['gclid', 'gbraid', 'wbraid', 'ttclid', 'ScCid', 'msclkid']
      visitTs = ''
      for (i = 0; i < visitKeys.length && !visitTs; i++) {
        value = route.get(visitKeys[i])
        if (!value) continue
        idType = visitKeys[i] === 'ScCid' ? 'sccid' : visitKeys[i]
        for (n = 0; n < list.length; n++) {
          if (list[n] && list[n].id_type === idType && list[n].click_id === value && list[n].ts) {
            visitTs = list[n].ts
            break
          }
        }
      }
      if (visitTs) route.set('ts', visitTs)
      return '/wa?' + route.toString()
    }
    winner = null
    winnerAt = -1
    for (i = 0; i < list.length; i++) {
      if (!list[i] || !list[i].click_id || !list[i].ts) continue
      if (!winner || list[i].ts > winner.ts || (list[i].ts === winner.ts && i > winnerAt)) {
        winner = list[i]
        winnerAt = i
      }
    }
    if (!winner) return '/wa?' + route.toString()
    key = winner.id_type === 'sccid' ? 'ScCid' : winner.id_type
    if (key) route.set(key, winner.click_id)
    if (winner.ts) route.set('ts', winner.ts)
    if (winner.ts_kind) route.set('ts_kind', winner.ts_kind)
    for (name in winner) {
      if (!Object.prototype.hasOwnProperty.call(winner, name)) continue
      if (name.indexOf('utm_') === 0 && winner[name]) route.set(name, winner[name])
    }
    if (key === 'fbclid' && data && data.fbc) route.set('fbc', data.fbc)
    return '/wa?' + route.toString()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchWaLinks)
  } else {
    patchWaLinks()
  }

  function syncAttrCookies() {
    if (typeof fetch !== 'function') return
    var params = new URLSearchParams(location.search)
    var ad = false
    params.forEach(function (v, k) {
      if (!v) return
      var key = String(k || '').toLowerCase()
      if (key.indexOf('utm_') === 0) ad = true
      if (
        key === 'gclid' ||
        key === 'gbraid' ||
        key === 'wbraid' ||
        key === 'fbclid' ||
        key === 'ttclid' ||
        key === 'sccid' ||
        key === 'msclkid'
      ) {
        ad = true
      }
    })
    var hasSid = /(?:^|; )wa_ref=/.test(document.cookie) || /(?:^|; )wa_sid=/.test(document.cookie)
    if (!ad && hasSid) return
    var syncKey = ad ? location.pathname + location.search : 'sid'
    if (window.__elAttrSync === syncKey) return
    window.__elAttrSync = syncKey
    var payload = JSON.stringify({
      referrer: document.referrer || '',
      page: location.href,
      query: location.search || '',
    })
    function postAttr(useKeepalive) {
      var opts = {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
      }
      if (useKeepalive) opts.keepalive = true
      return fetch('/api/attr', opts)
    }
    try {
      postAttr(true).catch(function () {
        postAttr(false).catch(function () {})
      })
    } catch (e) {
      try {
        postAttr(false).catch(function () {})
      } catch (err) {}
    }
  }

  syncAttrCookies()
}

export function getAttributionInlineScript() {
  return '(' + captureAttribution.toString() + ')();'
}

function readElAttrSid() {
  var match = document.cookie.match(/(?:^|; )el_attr=([^;]*)/)
  if (!match) return ''
  try {
    var data = JSON.parse(decodeURIComponent(match[1]))
    if (data && Number(data.v) === 2 && data.sid) return String(data.sid).replace(/^\s+|\s+$/g, '')
  } catch (e) {}
  return ''
}

function readStored() {
  if (typeof window === 'undefined') return {}

  var stored = {}
  try {
    stored = JSON.parse(localStorage.getItem(ATTRIBUTION_LS_KEY) || '{}') || {}
  } catch (e) {
    stored = {}
  }

  ATTRIBUTION_FIELD_KEYS.forEach(function (key) {
    var cookieKey = cookieName(key)
    var match = document.cookie.match(
      '(?:^|; )' + cookieKey.replace(/([$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
    )
    if (key === 'sid') {
      var elSid = readElAttrSid()
      if (elSid) {
        stored.sid = elSid
        return
      }
    }
    if (!match && key === 'sid') {
      match = document.cookie.match(/(?:^|; )wa_sid=([^;]*)/)
    }
    if (match) stored[key] = decodeURIComponent(match[1])
  })

  document.cookie.split(';').forEach(function (part) {
    var piece = part.replace(/^\s+/, '')
    var eq = piece.indexOf('=')
    if (eq === -1) return
    var name = piece.slice(0, eq)
    if (name.indexOf('utm_') !== 0) return
    try {
      stored[name] = decodeURIComponent(piece.slice(eq + 1))
    } catch (e) {
      stored[name] = piece.slice(eq + 1)
    }
  })

  if (stored.sid) stored.sid = String(stored.sid).replace(/^\s+|\s+$/g, '')

  Object.keys(stored).forEach(function (key) {
    if (key.indexOf('utm_') === 0 && stored[key] && ATTRIBUTION_FIELD_KEYS.indexOf(key) === -1) {
      ATTRIBUTION_FIELD_KEYS.push(key)
    }
  })

  return stored
}

export function getAttribution() {
  return readStored()
}

export function getSessionCode() {
  return readStored().sid || ''
}

export function getPagePath() {
  if (typeof window === 'undefined') return '/'
  var path = location.pathname || '/'
  if (path.charAt(0) !== '/' || path.indexOf('//') === 0) return '/'
  return path
}

export function createSubmissionId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID()
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0
    var v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function getAttributionFields() {
  var stored = readStored()
  var fields = {}

  Object.keys(stored).forEach(function (key) {
    if (stored[key] == null || stored[key] === '') return
    if (ATTRIBUTION_FIELD_KEYS.indexOf(key) !== -1 || key.indexOf('utm_') === 0) {
      fields[key] = String(stored[key])
    }
  })

  return fields
}

export function getFormAttributionPayload() {
  var fields = getAttributionFields()
  var touches = collectFormTouches(fields)
  var source = leadSourceFields(touches)
  var payload = {}
  var identity = ['referrer', 'landing_page', 'timestamp', 'sid']
  var i

  for (i = 0; i < identity.length; i++) {
    if (fields[identity[i]]) payload[identity[i]] = String(fields[identity[i]])
  }

  Object.keys(source).forEach(function (key) {
    payload[key] = source[key]
  })

  if (source.fbclid) {
    var fbc = matchingFbc(fields.fbc, source.fbclid)
    if (fbc) payload.fbc = fbc
  }

  payload.touches = touches
  payload.submitted_at = new Date().toISOString()
  return payload
}

export function buildWaRoute(pageUrl, src) {
  if (typeof window === 'undefined') {
    var serverParams = buildWaSearchParams({ src: src || 'site', path: '/' })
    return '/wa?' + serverParams.toString()
  }

  captureAttribution()
  var path = '/'

  try {
    path = new URL(pageUrl || location.href, location.origin).pathname || '/'
  } catch (e) {
    path = location.pathname || '/'
  }

  if (path.charAt(0) !== '/' || path.indexOf('//') === 0 || path.length > 120) path = '/'
  var fields = getAttributionFields()
  var params = buildWaSearchParams({
    src: src || 'site',
    path: path,
    search: location.search,
    touches: collectFormTouches(fields),
    fbc: fields.fbc || '',
  })
  return '/wa?' + params.toString()
}

export function buildWhatsAppUrl(href, pageUrl, src) {
  return buildWaRoute(pageUrl, src)
}

let sendAttribution = null

export function pushAttribution() {
  if (typeof window === 'undefined' || typeof sendAttribution !== 'function') return

  captureAttribution()
  var fields = getAttributionFields()
  if (!fields.sid) return

  var payload = JSON.stringify(fields)
  var last = ''
  try {
    last = localStorage.getItem(ATTRIBUTION_SYNC_LS_KEY) || ''
  } catch (e) {}
  if (last === payload) return

  Promise.resolve(sendAttribution(fields))
    .then(function () {
      try {
        localStorage.setItem(ATTRIBUTION_SYNC_LS_KEY, payload)
      } catch (e) {}
    })
    .catch(function () {})
}

function isClinicWhatsAppHref(href) {
  if (!href) return false
  if (href.indexOf('wa.me') !== -1) return true
  if (href === '/wa' || href.indexOf('/wa?') === 0 || href.indexOf('/wa#') === 0) return true
  return false
}

function rewriteWhatsAppLinks() {
  if (typeof document === 'undefined') return
  var links = document.querySelectorAll('a[href*="wa.me"]')
  var i
  var next
  for (i = 0; i < links.length; i++) {
    next = buildWaRoute(location.href, 'content')
    if (next) links[i].setAttribute('href', next)
  }
}

function onWhatsAppClick(event) {
  var link = event.target && event.target.closest && event.target.closest('a[href]')
  if (!link) return
  var href = link.getAttribute('href') || ''
  if (!isClinicWhatsAppHref(href)) return
  var next = buildWaRoute(location.href, link.getAttribute('data-wa-src') || 'content')
  if (!next) return
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    link.setAttribute('href', next)
    return
  }
  if (event.defaultPrevented || event.button !== 0) return
  event.preventDefault()
  if (link.getAttribute('target') === '_blank') {
    window.open(next, '_blank', 'noopener,noreferrer')
    return
  }
  window.location.assign(next)
}

let clickBound = false
let observerBound = false

function currentTouchPayload() {
  var params = new URLSearchParams(location.search)
  var stored = getAttribution()
  var payload = {}
  var any = false

  CLICK_ID_KEYS.forEach(function (key) {
    var value = params.get(key)
    if (value && stored[key] === value) {
      payload[key] = value
      any = true
    }
  })

  params.forEach(function (value, key) {
    if (key.indexOf('utm_') !== 0 || !value) return
    payload[key] = value.length > 150 ? value.slice(0, 150) : value
    any = true
  })

  if (!any) return null

  payload.sid = String(stored.sid || '').replace(/^\s+|\s+$/g, '')
  payload.fbc = stored.fbc || ''
  payload.referrer = stored.referrer || ''
  payload.timestamp = new Date().toISOString()
  payload.touches = collectFormTouches(stored)
  var page = params.get('p')
  if (page) payload.p = page
  return payload
}

export function initAttribution(send) {
  if (typeof window === 'undefined') return
  if (typeof send === 'function') sendAttribution = send
  captureAttribution()
  var touch = currentTouchPayload()
  if (touch) api.touch(touch).catch(function () {})
  rewriteWhatsAppLinks()
  setTimeout(rewriteWhatsAppLinks, 0)
  setTimeout(rewriteWhatsAppLinks, 300)
  if (!clickBound) {
    clickBound = true
    document.addEventListener('click', onWhatsAppClick, true)
  }
  if (!observerBound && typeof MutationObserver !== 'undefined' && document.documentElement) {
    observerBound = true
    var observer = new MutationObserver(function () {
      rewriteWhatsAppLinks()
    })
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href'],
    })
  }
}
